import { useState } from 'react'
import { Modal } from '@/components/ui/Modal'
import { PARCEIRO_TERMOS_SECOES, PARCEIRO_TERMOS_TITULO, PARCEIRO_TERMOS_VERSAO } from './parceiroProgramaTermos'

export function ParceiroTermosModal({ open, onClose }: { open: boolean; onClose: () => void }) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={PARCEIRO_TERMOS_TITULO}
      description={`Versão ${PARCEIRO_TERMOS_VERSAO}`}
      size='xl'
      className='!bg-[#160828] !text-white'
    >
      <div className='grid gap-5 text-sm leading-6 text-white/80'>
        {PARCEIRO_TERMOS_SECOES.map((secao) => (
          <section key={secao.titulo} className='grid gap-2'>
            <h3 className='font-semibold text-white'>{secao.titulo}</h3>
            {secao.paragrafos.map((paragrafo) => (
              <p key={paragrafo}>{paragrafo}</p>
            ))}
          </section>
        ))}
      </div>
    </Modal>
  )
}

export function ParceiroTermosLeitura({ label = 'Ler regras completas' }: { label?: string }) {
  const [open, setOpen] = useState(false)

  return (
    <>
      <button
        type='button'
        onClick={() => setOpen(true)}
        className='w-fit text-sm font-medium text-[#ff8fbd] underline-offset-4 hover:underline'
      >
        {label}
      </button>
      <ParceiroTermosModal open={open} onClose={() => setOpen(false)} />
    </>
  )
}

type Props = {
  checked: boolean
  onChange: (checked: boolean) => void
}

export function ParceiroTermosAceite({ checked, onChange }: Props) {
  const [open, setOpen] = useState(false)

  return (
    <div className='grid gap-3'>
      <button
        type='button'
        onClick={() => setOpen(true)}
        className='w-fit text-sm font-medium text-[#ff8fbd] underline-offset-4 hover:underline'
      >
        Ler regras
      </button>
      <label className='flex items-start gap-3 text-sm leading-5 text-white/80'>
        <input
          type='checkbox'
          className='mt-1 h-4 w-4 shrink-0 accent-[#e91e63]'
          checked={checked}
          onChange={(event) => onChange(event.target.checked)}
          required
        />
        <span>Li e concordo com as regras do programa de indicação da Rocket Search.</span>
      </label>
      <ParceiroTermosModal open={open} onClose={() => setOpen(false)} />
    </div>
  )
}
